// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__cdy65","left":"Heading_left__gAX1S","title":"Heading_title__NMMzc","text":"Heading_text__Air9q"};